var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { navigationView } from "../Shared/NavigationView";
import { NoteUITrack, SoundFileUITrack } from "../Shared/UITrack";
import { FAButton } from "../SharedReact/BasicElements";
import { LoadingErrorModal } from "../SharedReact/Modal";
import { UITrackStore } from "./UITrackStore";
export class SerialisePanel extends React.Component {
    constructor(props) {
        super(props);
        this._modalCloseFunc = () => { this.setState({ modalShown: false }); };
        this.state = {
            modalShown: false,
            modalLoading: true,
            modalText: ""
        };
        this._serialise = this._serialise.bind(this);
        this._deserialise = this._deserialise.bind(this);
        this._getFile = this._getFile.bind(this);
        this._saveToWAV = this._saveToWAV.bind(this);
        this._inputRef = React.createRef();
    }
    _serialise() {
        this.setState({ modalShown: true, modalLoading: true, modalText: "Saving to File..." });
        let tracks = UITrackStore.getState().tracks.map(t => t.serialise());
        let modelSettings = this.props.songManager.serialise();
        let songSettings = Object.assign(Object.assign({}, modelSettings), { UITracks: tracks });
        let outputString = JSON.stringify(songSettings);
        let a = document.createElement("a");
        let file = new Blob([outputString], { type: "application/web-sequencer" });
        a.href = URL.createObjectURL(file);
        a.download = new Date().toLocaleDateString() + ".sqn";
        a.click();
        this.setState({ modalShown: false });
    }
    _deserialise() {
        this._inputRef.current.click();
    }
    _getFile(event) {
        this.setState({ modalShown: true, modalLoading: true, modalText: "Loading File..." });
        const file = event.target.files[0];
        if (!file) {
            this.setState({ modalLoading: false, modalText: "Invalid File" });
            return;
        }
        else {
            let reader = new FileReader();
            reader.onloadend = () => __awaiter(this, void 0, void 0, function* () {
                let parsed = JSON.parse(reader.result);
                if (!(typeof parsed === 'object' && parsed.hasOwnProperty("fileType") && parsed.fileType == "SequencerSongSettings")) {
                    console.log("Invalid file type.");
                    return;
                }
                yield this.props.songManager.deserialise(parsed);
                let UITracks = [];
                for (let i = 0; i < parsed.UITracks.length; i++) {
                    let track = parsed.UITracks[i];
                    let baseTrack = this.props.songManager.tracks.find(modelTrack => modelTrack.id == track.modelTrackID);
                    if (baseTrack == undefined) {
                        console.log("UITrack with missing ID found: ", track);
                        continue;
                    }
                    switch (track.type) {
                        case "oscillator":
                            UITracks.push(new NoteUITrack(track, baseTrack));
                            break;
                        case "soundFile":
                            UITracks.push(new SoundFileUITrack(track, baseTrack));
                            break;
                        default:
                            console.log("Invalid track type: ", track.type);
                            break;
                    }
                }
                UITrackStore.dispatch({ type: "SET_TRACKS", tracks: UITracks });
                while (navigationView.viewDepth > 1) {
                    navigationView.back();
                }
                this.setState({ modalShown: false });
            });
            reader.readAsText(file);
        }
    }
    _saveToWAV() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ modalShown: true, modalLoading: true, modalText: "Generating WAV..." });
            let file = null;
            try {
                file = yield this.props.songManager.saveToWAV();
            }
            catch (_a) {
                this.setState({ modalLoading: false, modalText: "Please add events to the song before saving." });
                return;
            }
            let a = document.createElement("a");
            a.href = URL.createObjectURL(file);
            a.download = new Date().toLocaleDateString() + ".wav";
            a.click();
            this.setState({ modalShown: false, modalText: "" });
        });
    }
    componentDidMount() {
        this._inputRef.current.addEventListener("change", this._getFile);
    }
    componentWillUnmount() {
        this._inputRef.current.removeEventListener("change", this._getFile);
    }
    render() {
        let c = "panelButton buttonAnim";
        return React.createElement("div", { className: "serialisePanel" },
            React.createElement(FAButton, { className: c, title: "Save File", iconName: "fa fa-save", onClick: this._serialise }),
            React.createElement(FAButton, { className: c, title: "Open File", iconName: "fa fa-folder-open", onClick: this._deserialise }),
            React.createElement(FAButton, { className: c, title: "Download as WAV", iconName: "fa fa-music", onClick: this._saveToWAV }),
            this.state.modalShown && React.createElement(LoadingErrorModal, { loading: this.state.modalLoading, title: this.state.modalText, onClose: this._modalCloseFunc }),
            React.createElement("input", { type: "file", ref: this._inputRef, accept: ".sqn", style: { position: "absolute", top: "-9999px" } }));
    }
}
//# sourceMappingURL=SerialisePanel.js.map